// frontend/src/components/ErrorBoundary.js

import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { AlertTriangle } from 'react-feather';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service like Sentry or LogRocket
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh', padding: '1rem' }}>
            <Alert variant="danger" className="text-center">
                <Alert.Heading>
                    <AlertTriangle size={32} className="me-2" />
                    Oops! Something went wrong.
                </Alert.Heading>
                <p>
                    An unexpected error occurred in the application.
                    Please try refreshing the page.
                </p>
                <hr />
                <div className="d-flex justify-content-end">
                    <Button onClick={() => window.location.reload()} variant="outline-danger">
                        Refresh Page
                    </Button>
                </div>
                {process.env.NODE_ENV === 'development' && (
                    <details className="mt-3 text-start small">
                        <summary>Error Details</summary>
                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                            {this.state.error && this.state.error.toString()}
                            <br />
                            {this.state.errorInfo && this.state.errorInfo.componentStack}
                        </pre>
                    </details>
                )}
            </Alert>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;